import { render, staticRenderFns } from "./AccidentReport.vue?vue&type=template&id=72097187&"
import script from "./AccidentReport.vue?vue&type=script&lang=js&"
export * from "./AccidentReport.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./AccidentReport.vue?vue&type=style&index=1&id=72097187&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports